import { Component, computed, Inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { AgGridModule } from 'ag-grid-angular';
import { IconButtonCellRendererComponent } from '../../util/icon-button-cell-renderer-component/icon-button-cell-renderer-component';
import { ColDef } from 'ag-grid-community';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoadingOverlayComponent } from '../../util/loading-overlay-component/loading-overlay-component';
import { TechnologyPriorityListComponent } from './technology-priority-list-component/technology-priority-list-component';
import { MatToolbarModule } from "@angular/material/toolbar";

@Component({
  selector: 'app-configuration-modal-component',
  imports: [
    MatDialogModule,
    MatStepperModule,
    NgSelectModule,
    AgGridModule,
    MatButtonModule,
    FormsModule,
    MatIconModule,
    MatToolbarModule
],
  templateUrl: './configuration-modal-component.html',
  styleUrl: './configuration-modal-component.css',
})
export class ConfigurationModalComponent {
  columns: ColDef[] = [
    { 
      headerName: 'Nom', 
      field: 'name' 
    }, 
    { 
      headerName: '',
      width: 50, 
      cellRenderer: IconButtonCellRendererComponent, 
      cellRendererParams: { icon: 'delete', tooltip: 'Supprimer la typologie' },
      filter: false,
      sortable: false,
      suppressHeaderMenuButton: true,
    }
  ];

  technologyColumns: ColDef[] = [
    { 
      headerName: 'Nom', 
      field: 'name',
      editable: true,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: ['FTTO Burst', 'FTTO', 'FTTE', 'FTTH'],
      },
      rowDrag: true,
    }, 
    { 
      headerName: 'Débit min.', 
      field: 'minimalRate',
      editable: true,
      width: 100,
    }, 
    { 
      headerName: '',
      width: 50, 
      cellRenderer: IconButtonCellRendererComponent, 
      cellRendererParams: { 
        icon: 'settings',
        tooltip: 'Configurer la technologie',
        onClick: (data: any) => this.dialog.open(TechnologyPriorityListComponent, 
          { 
            data: data,
            width: '40%',
            height: '60%' 
          }) 
      },
      filter: false,
      sortable: false,
      suppressHeaderMenuButton: true,
    }, 
    { 
      headerName: '',
      width: 50, 
      cellRenderer: IconButtonCellRendererComponent, 
      cellRendererParams: { icon: 'delete', tooltip: 'Supprimer la technologie' },
      filter: false,
      sortable: false,
      suppressHeaderMenuButton: true,
    }
  ];

  public readonly gridRowSelection: any = {
    mode: 'singleRow',
    enableClickSelection: true,
    checkboxes: false
  };

  public readonly toBeAddedTechnology = model<any>(null);

  public readonly rowData = signal<any[]>(
    [
      {
        name: 'Par défaut', 
        accesses: [
          {
            name: 'Accès 1', 
            technologiesList: []
          }, 
          {
            name: 'Accès 2', 
            technologiesList: []
          }
        ]
      },
      {name: 'Magasin', accesses: [{name: 'Accès 1', technologiesList: []}, {name: 'Accès 2', technologiesList: []}]},
      {name: 'Entrepôt', accesses: [{name: 'Accès 1', technologiesList: []}, {name: 'Accès 2', technologiesList: []}]}
    ]
  );

  public readonly loadingOverlayComponentAccess: any = LoadingOverlayComponent;
  public readonly loadingOverlayComponentAccessParams: any = { loadingMessage: 'Veuillez sélectionner une typologie de site pour éditer les accès', displaySpinner: false };
  public readonly loadingOverlayComponentOffers: any = LoadingOverlayComponent;
  public readonly loadingOverlayComponentOffersParams: any = { loadingMessage: 'Veuillez sélectionner un accès pour éditer les offres', displaySpinner: false };

  public readonly selectedSiteTypology = signal<any>(null);
  public readonly selectedAccess = signal<any>(null);
  public readonly technologiesList = computed<any>(() =>{ 
    return this.selectedAccess()?.technologiesList || []
  });

  constructor(
    private readonly dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {}

  selectSiteTypology(event: any) {
    this.selectedSiteTypology.set(event.data);
    this.selectedAccess.set(null);
    this.toBeAddedTechnology.set(null);
  }

  selectAccess(event: any) { 
    this.selectedAccess.set(event.data);
    this.toBeAddedTechnology.set(null);
  }

  addTechnology() {
    const updatedTechnologies = [
      ...(this.technologiesList()),
      { name: null, minimalRate: '0' }
    ];
    
    this.selectedAccess.update((access: any) => ({
      ...access,
      technologiesList: updatedTechnologies
    }));

    this.toBeAddedTechnology.set(null);
  }
}
